import React, { useEffect, useRef, useState } from 'react';
import { Button, Snackbar, SnackbarContent } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { checkMemberIssues } from '../actions/audit';
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';

export const AuditSnackbar = ({ result, onClose }) => (
    <Snackbar open={Boolean(result)} onClose={onClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
        <SnackbarContent
            style={{ backgroundColor: result && result.has_issues ? '#b71c1c' : '#1b5e20', maxWidth: 900 }}
            message={result ? result.message : ''}
            action={<Button color="inherit" onClick={onClose}>Close</Button>}
        />
    </Snackbar>
);

const CheckForIssues = ({ member, onResult }) => {
    const dispatch = useDispatch();
    const [checking, setChecking] = useState(false);
    const mounted = useRef(true);
    useEffect(() => () => { mounted.current = false; }, []);
    const check = async () => {
        if (member.audit_excluded) return;
        setChecking(true);
        try {
            const data = await dispatch(checkMemberIssues(member._id));
            onResult({ ...data.member, message: member.clinic_name + ': ' + data.message });
        } catch (error) {
            onResult({ has_issues: true, message: member.clinic_name + ': ' +
                ((error.response && error.response.data && error.response.data.message) || 'The audit could not be completed. Please try again.') });
        } finally { if (mounted.current) setChecking(false); }
    };
    return <Button size="small" variant="outlined" color="secondary" startIcon={<PlaylistAddCheckIcon fontSize="small" />}
        disabled={checking || Boolean(member.audit_excluded)} onClick={check}>
        {member.audit_excluded ? 'Excluded from audits' : checking ? 'Checking...' : 'Check for issues'}
    </Button>;
};

export default CheckForIssues;
